export const APP_CONFIG = {
  name: "Innov' Paie",
  version: '3.1.0',
  description: "Plateforme d'automatisation pour OpenPaye",
  url: 'https://app.innov-paie.fr',
  api: {
    baseUrl:
      import.meta.env.VITE_API_BASE_URL || 'https://api.innov-paie.fr/api/v1',
    // baseUrl: 'http://localhost:3014/api/v1',
    timeout: 10000,
  },
  auth: {
    tokenKey: 'openpaye_tokens',
    userKey: 'openpaye_user',
  },
  pagination: {
    defaultPageSize: 20,
    maxPageSize: 100,
  },
  languages: ['fr', 'en'] as const,
  defaultLanguage: 'fr' as const,
} as const;

export const ROUTES = {
  HOME: '/',
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
  },
  DASHBOARD: '/dashboard',
  DOMAINS: '/domains',
  FOLDERS: '/folders',
  AUTOMATION: '/automation',
  ASSISTANT: '/assistant',
  DOCUMENTS: '/documents',
  VAULT: '/vault',
  TEMPLATES: '/templates',
  CHANGELOG: '/changelog',
  SUPPORT: '/support',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  // Ancienne route paiement retirée
  ORGANISATIONS: '/organisations',
  // C3 — SIRH. Ajout, sans toucher aux routes existantes.
  // C4 — BDESE. Le chantier C4 n'a pas pu poser ces routes : son worktree ne
  // contenait pas le front. Elles arrivent ici.
  BDESE: {
    EXERCICES: '/bdese/:folderUuid',
    EXERCICE: '/bdese/:folderUuid/exercice/:reportUuid',
    SAISIE: '/bdese/:folderUuid/exercice/:reportUuid/completer',
  },
  SIRH: {
    MY_LEAVE: '/absences',
    APPROVALS: '/absences/approbations',
    VARIABLES: '/variables/:folderUuid',
  },
  INVOICES: '/invoices',
  // La documentation de l'assistant, dans l'application (pas de site externe).
  AIDE: {
    ASSISTANT: '/aide/assistant',
  },
  LEGAL: {
    TERMS: '/legal/terms',
    PRIVACY: '/legal/privacy',
    NOTICES: '/legal/notices',
  },
} as const;
